import * as React from 'react';
import { IApplicationContext } from '../../types/applicationContext';

export const Context = React.createContext<IApplicationContext | null>(null);
